<template>
	<div class="amount">
		<span
			class="amount__value"
			:style="{
				fontSize: `${fontSize / 16}rem`,
				lineHeight: `${fontSize / 16}rem`,
				fontWeight: fontWeight,
			}"
		>
			{{
				(sign
					? sign === ResourceChangeHighlight.POSITIVE
						? "+"
						: "-"
					: "") +
				formatNumber(amount) +
				"x"
			}}
		</span>
		<AppMainIcon
			v-if="currency"
			:iconName="currency"
			:iconSize="iconSize"
		/>
		<div v-if="frameName" :class="`icon-${currentTileIcon}-${iconSize}`" />
	</div>
</template>

<script lang="ts" setup>
import AppMainIcon from "@/components/AppMainIcon.vue";
import type { FrameName } from "@/game/entities/config";
import type { ResourceType } from "@/game/entities/config/resources";
import { FontWeights, ResourceChangeHighlight } from "@/types/ui";
import { formatNumber } from "@/utils/format";
import { getTileIconName } from "@/utils/tileIconName";
import { computed } from "vue";

interface Props {
	amount: number;
	currency?: ResourceType | null;
	frameName?: FrameName;
	resourceChangeHighlight?: ResourceChangeHighlight | null;
	resourceChangeSign?: ResourceChangeHighlight | null;
	iconSize?: number;
	fontSize?: number; // in px
	fontWeight?: FontWeights;
}

const {
	amount = 0,
	currency = null,
	frameName = null,
	resourceChangeHighlight = ResourceChangeHighlight.POSITIVE,
	resourceChangeSign = null,
	iconSize = 20,
	fontSize = 16,
	fontWeight = FontWeights.BOLD, // NOTE: default: bold
} = defineProps<Props>();

const currentTileIcon = computed((): string => {
	if (!frameName) return "";
	return getTileIconName(frameName);
});

const sign = computed((): ResourceChangeHighlight | null => {
	return resourceChangeSign === null
		? resourceChangeHighlight
		: resourceChangeSign;
});
</script>

<style lang="scss" scoped>
.amount {
	@include flex-row-center;
	gap: 0.25rem;
	margin: 0 0.2rem;

	span {
		color: #f2dcb5;
		line-height: 1rem;
		text-shadow: 0.044rem 0.044rem 0.063rem rgba(0, 0, 0, 0.6);
	}

	.icon {
		// FRV
		margin-top: 0.25rem;
	}
}
</style>
